/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOnlineDetector = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13 14v8h-2v-8zm6.7-12.714C21.82 3.364 23 6.033 23 9c0 2.743-1.128 5.378-3.043 7.445l-.243.255-1.428-1.4C19.996 13.556 21 11.31 21 9c0-2.31-.873-4.387-2.477-6.06l-.223-.226zM4.286 1.3l1.428 1.4C4.004 4.444 3 6.69 3 9c0 2.204.915 4.351 2.485 6.059l.229.24L4.286 16.7C2.224 14.597 1 11.858 1 9c0-2.743 1.128-5.378 3.043-7.445zm12.931 3.033A6.977 6.977 0 0 1 19 9a6.99 6.99 0 0 1-2.91 5.68l-.22.153-1.106-1.666A4.992 4.992 0 0 0 17 9a4.975 4.975 0 0 0-1.104-3.134l-.17-.2zm-10.435 0 1.49 1.334A4.978 4.978 0 0 0 7 9a4.99 4.99 0 0 0 2.042 4.031l.194.136-1.107 1.666A6.992 6.992 0 0 1 5 9a6.98 6.98 0 0 1 1.587-4.438zM12 6a3 3 0 1 1-.001 6.001A3 3 0 0 1 12 6zm0 2a1 1 0 1 0 .001 2.001A1 1 0 0 0 12 8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgOnlineDetector as OnlineDetector };
